import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SortBuy from "../../components/dropdown/SortBuy";
import "./style.css";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import { Dropdown } from "react-bootstrap";

import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import jobImage from "../../assets/images/khoj-images/image 490.png";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";

function SavedSec(props) {
	const sessionId = localStorage.getItem("sessionId");

	// ...............................All Job List Start.......................................
	const userUID = localStorage.getItem("userUID");

	const [page, setPage] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [jobsavedList, setSavedjobList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(0);
	const [search, setSearch] = useState([]);
	const [isError, setIsError] = useState(false);

	const getAllSavedjob = (page) => {
		try {
			const data = {
				sessionId: sessionId,
				// pageNumber: page,
				pageSize: 10,
			};
			console.log("data====>", data);

			axios.post(`/Job/GetSavedJobs`, data).then((response) => {
				const res = response.data.responseData.jobsList;
				console.log("saved Job==>", res);
				setSavedjobList(res);
				// setTotalPages(response.data.responseData.paging.totalPages);
				setIsLoading(false);
			});
		} catch (e) {
			console.log("Error fetching saved jobs", e);
			setIsLoading(false);
			if (e.response && e.response.status === 404) {
				setSavedjobList([]); // Clear list if not found
			}
		}
	};
	useEffect(() => {
		getAllSavedjob();
	}, [search]);




	// console.log("Saved jobList", jobsavedList);

	// ...............................All Jobs List End.......................................

	// ................................UnSavedJob Start....................

	const [savedjob, setSavedjob] = useState("");
	const UnSavedJob = async (jobId) => {
		const data = {
			sessionId: sessionId,
			jobId: jobId,
		};
		console.log("session ids", sessionId);

		try {
			await axios.post("/JobAction/UnSaveJob", data).then((resData) => {
				console.log("UnSaved job", resData.data.message);
				setSavedjobList((prev) => prev.filter((item) => item.jobId !== jobId));
				toast.success(resData.data.message);
				getAllSavedjob();
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.warning(e.response.data.message);
				console.log("Unsaved ");
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	// ........................................UnSavedJob End..........................

	const columns = [
		{
			name: "Jobs Name",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => (
				<div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
					<div className="job-img text-center">
						<img
							src={row.compImage}
							alt="User"
							style={{ width: "50px", height: "50px", borderRadius: "50%" }}
						/>
					</div>
					<div className="content">
						<div
							className="justify-content-center"
							style={{ display: "flex", alignItems: "center", gap: "10px" }}
						>
							<div className="pointer jobinfo f-600 ">
								<a href={`/jobDetails/${row.jobId}`}>{row.title}</a>
							</div>
						</div>

					</div>
				</div>
			),
		},

		{
			name: "Designation",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.designationName,
		},
		{
			name: "Post Datw",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => <div className="pointer text-center">
				{moment(row.creationTime).format("DD  MMM YYYY")}
			</div>,
		},
		{
			name: "City Name",
			center: true,
			sortable: true,
			minWidth: "200px",
			selector: (row) => row.cityName,
		},
		{
			name: "Action",
			center: true,
			minWidth: "200px",
			cell: (row) => (
				<>
					<Dropdown>
						<Dropdown.Toggle as="span" className="icon-togg">
							<MoreHorizSharpIcon className="ms-2" />
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item href={`/jobDetails/${row.jobId}`}>
								View Job
							</Dropdown.Item>
							<Dropdown.Item
								href="#"
								onClick={() => {
									UnSavedJob(row.jobId);
									getAllSavedjob();
								}}
							>
								UnSaved
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</>
			),
		},
	];

	return (
		<section className="pricing-section-three container jobapplication view-job-style  pt-5">
			<div className="mt-2">
				<h6 className="orange-title">
					<span className="orange-box me-2"></span>
					{props.title}
				</h6>
			</div>
			<div className="container st3">
				<div className="row">
					<div className="col-lg-12">
						{isError ? (
							console.log("Data not found")
						) : (
							<div className="scroll-react-dataTable">

								<div className="react-dataTable">
									<DataTable
										noHeader
										pagination
										columns={columns}
										paginationPerPage={7}
										className="react-dataTable"
										sortIcon={<ChevronDown size={10} />}
										paginationDefaultPage={currentPage + 1}
										data={jobsavedList}
									/>
								</div>

							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	);
}

export default SavedSec;
